import React, { Component } from "react";
import { Divider, Row, Layout, Popover, Icon, Input } from "antd";
import AllEnemiesTable from "../table/AllEnemiesTable";
import axios from "axios";
import throttle from "lodash.throttle";
import PropTypes from "prop-types";
import ReactGA from "react-ga4";
// import HorizontalAdPopup from "../ads/HorizontalAdPopup";
import version from "./version";

const { Sider, Content } = Layout;

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

// const EnemyList = {
//   sampledata: [
//     {
//       enemy_no: "000",
//       enemy_name_en: "Doge",
//       type: "White ",
//     },
//     {
//       enemy_no: "001",
//       enemy_name_en: "Snache",
//       type: "White ",
//     },
//     {
//       enemy_no: "002",
//       enemy_name_en: "Those Guys",
//       type: "White ",
//     },
//   ],
// };

class AllEnemies extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedEnemies: [],
      viewportHeight: 0,
      dataSource: [],
      someVal: "",
      // compareCatsLevels: 30,
    };
  }

  componentDidMount() {
    document.title = "All Battle Cats Enemies | Battle Cats Wiki for Cat Stats";

    this.saveViewportDimensions();
    window.addEventListener("resize", this.saveViewportDimensions);

    // initGAseView();

    axios
      .get("https://onestoppress.com/api/allenemies")
      .then((res) => {
        let EnemyList = res.data.sampledata;

        this.setState({ dataSource: EnemyList }, function () {
          // console.log("state: ", this.state.dataSource);
        });
        this.setState({ selectedEnemies: EnemyList });
      })
      .catch((err) => console.log("err: ", err));

    // this.setState({ dataSource: EnemyList.sampledata });
    // this.setState({ selectedEnemies: EnemyList.sampledata });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.saveViewportDimensions);
  }

  saveViewportDimensions = throttle(() => {
    let adjustViewport;
    if (window.innerWidth < 768) {
      adjustViewport = 135;
    } else {
      adjustViewport = 290;
    }

    this.setState({
      viewportHeight: window.innerHeight - adjustViewport,
    });
  }, this.props.applyViewportChange);

  onChange = (e) => {
    this.setState({ someVal: e.target.value });
    let dataSource = this.state.dataSource;
    // console.log("value: " + e.target.value);
    // console.log("typeof value: " + typeof e.target.value);
    if (typeof e.target.value !== "undefined") {
      // console.log("value: " + e.target.value);
      let selectedEnemies = dataSource.filter((enemy) =>
        enemy.enemy_name_en.toLowerCase().includes(e.target.value.toLowerCase())
      );
      this.setState({ selectedEnemies: selectedEnemies });
      // console.log(selectedEnemies);
    }
  };

  render() {
    return (
      <div>
        <div className="pagetitle">
          <h1
            style={{
              padding: "10px 0 0 0",
              marginBottom: "6px",
              float: "left",
            }}
          >
            All Enemies
          </h1>
          <div style={{ paddingTop: "10px" }}>
            <Popover
              content={<div>Updated to BattleCats Version {version}</div>}
              placement="bottomRight"
            >
              <Icon type="info-circle" />
            </Popover>
          </div>

          <Divider style={{ margin: "0 0 0 0", padding: "0 0 0 0" }} />
        </div>

        <Layout>
          <Sider
            width={220}
            className="sider filter"
            style={{
              padding: "0 12px 0 12px",
              background: "white",
              display: "none",
            }}
          ></Sider>
          <Layout style={{ padding: "0 12px 0 12px", background: "white" }}>
            <Content style={{ padding: "0 0px" }} className="flexible-width">
              <Row style={{ padding: "16px 0 16px 0" }}>
                <Input
                  suffix={
                    <Icon type="search" className="certain-category-icon" />
                  }
                  style={{
                    opacity: "1",
                    float: "right",
                    display: "block",
                    maxWidth: "350px",
                  }}
                  allowClear
                  placeholder="Search enemies by name"
                  onChange={this.onChange}
                  value={this.state.someVal || ""}
                />
              </Row>
              <Row style={{ padding: "0px 0 0px 0" }}>
                <AllEnemiesTable
                  selectedEnemies={this.state.selectedEnemies}
                  viewportHeight={this.state.viewportHeight}
                />
              </Row>
              <Row style={{ height: "50px" }}> </Row>
            </Content>
          </Layout>
        </Layout>
        {/* <HorizontalAdPopup
          dataAdClient="ca-pub-1920730948516638"
          dataAdSlot="7534695650"
        ></HorizontalAdPopup> */}
      </div>
    );
  }
}

export default AllEnemies;

AllEnemies.propTypes = {
  applyViewportChange: PropTypes.number,
};

AllEnemies.defaultProps = {
  applyViewportChange: 250,
};



// WEBPACK FOOTER //
// ./src/components-kr/content/AllEnemies.js